import { render, staticRenderFns } from "./Substring.vue?vue&type=template&id=8d536a18&"
import script from "./Substring.vue?vue&type=script&lang=ts&"
export * from "./Substring.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports